class BlockCareers {
	constructor(el) {
		this.el = el;
		this.select = el.querySelector('.block-careers__location-select');
		this.jobListings = document.querySelectorAll('.block-careers__job-listing-link');

		this.init();
	}

	init = () => {
		if (!this.select) {
			return;
		}
		this.select.addEventListener('change', this.handleSelectChange);
	};

	handleSelectChange = (e) => {
		e.preventDefault();

		this.jobListings.forEach((jobListing) => {
			if (e.target.value === 'all') {
				jobListing.style.display = 'block';
			} else if (jobListing.getAttribute('data-location') === e.target.value) {
				jobListing.style.display = 'block';
			} else {
				jobListing.style.display = 'none';
			}
		});
	};
}

export default BlockCareers;
